// import theme from 'presentation/styles/theme'
import styled, { css } from 'styled-components'
import { CardProps } from '.'

type CardWrapperProps = Pick<
  CardProps,
  'shadow' | 'radius' | 'bgColor' | 'disabled' | 'highlight'
>
type IconWrapperProps = Pick<CardProps, 'iconColor'>
type CardClickProps = Pick<CardProps, 'disabled' | 'onClick'>

export const CardWrapper = styled.div<CardWrapperProps>`
  ${({
    theme,
    shadow = 'medium',
    radius = 'xsmall',
    bgColor = 'white',
    disabled = false,
    highlight
  }) => css`
    position: relative;
    display: flex;
    flex-direction: column;
    background: ${disabled
      ? theme.ds.colors.neutral100
      : theme.ds.colors[bgColor]};
    box-shadow: ${highlight ? 'none' : theme.ds.shadows[shadow]};
    border: ${highlight ? `1px solid ${theme.ds.colors.primary300}` : 'none'};
    border-radius: ${theme.ds.typography.border.radius[radius]};
  `}
`

export const IconWrapper = styled.div<IconWrapperProps>`
  ${({ theme, iconColor }) => css`
    display: flex;
    padding: 4px 16px 4px 0;

    svg {
      width: 32px;
      height: 32px;

      path {
        fill: ${theme.ds.colors[iconColor!]};
      }
    }
  `}
`

export const CardHeader = styled.div<CardClickProps>`
  ${({ disabled = false, onClick }) => css`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 24px;
    cursor: ${onClick && !disabled ? 'pointer' : 'default'};
  `}
`

export const CardContent = styled.div`
  ${({ theme }) => css`
    border-top: 1px solid ${theme.ds.colors.neutral200};
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    height: 100%;

    @media (max-width: 800px) {
      display: block;
      height: auto;
    }
  `}
`

export const CardSubCounter = styled.div<CardClickProps>`
  ${({ theme, disabled = false, onClick }) => css`
    height: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 16px;
    text-align: center;
    padding: 16px;
    cursor: ${onClick && !disabled ? 'pointer' : 'default'};

    &:not(:last-child) {
      border-right: 1px solid ${theme.ds.colors.neutral200};
    }

    @media (max-width: 800px) {
      height: auto;

      &:not(:last-child) {
        border-right: none;
        border-bottom: 1px solid ${theme.ds.colors.neutral200};
      }
    }
  `}
`

export const ValuesWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
`
